module.exports = __webpack_public_path__ + "static/examp2-7afea113c8c12a973a7e42d89c62d41b.gif";